import React from 'react';
import { Link } from 'react-router-dom';

import {
    Building2,
    Shield,
    Heart,
    Briefcase,
    GraduationCap,
    ArrowRight
} from 'lucide-react';
import './ModernIndustries.scss';

const ModernIndustries = () => {
    const industries = [
        {
            icon: <Building2 size={32} />,
            title: 'Federal Civilian',
            description: 'Comprehensive IT solutions for federal government agencies and departments.',
            link: '/federal-civilian',
            stats: '200+ Agencies'
        },
        {
            icon: <Shield size={32} />,
            title: 'Department of Defense',
            description: 'Secure technology solutions meeting military standards and requirements.',
            link: '/department',
            stats: 'All Branches'
        },
        {
            icon: <Heart size={32} />,
            title: 'Healthcare',
            description: 'HIPAA-compliant solutions for healthcare providers and organizations.',
            link: '/health-care',
            stats: '50+ Providers'
        },
        {
            icon: <Briefcase size={32} />,
            title: 'Commercial',
            description: 'Enterprise technology solutions for businesses of all sizes.',
            link: '/commercial',
            stats: '300+ Companies'
        },
        {
            icon: <GraduationCap size={32} />,
            title: 'SLED',
            description: 'State, Local, and Education technology procurement and support.',
            link: '/sled',
            stats: '100+ Institutions'
        }
    ];

    return (
        <section className="jk-industries">
            <div className="jk-industries__container">
                {/* Header */}
                <div className="jk-industries__header">
                    <span className="jk-section-label">
                        <Building2 size={16} />
                        Industries We Serve
                    </span>
                    <h2 className="jk-industries__title">
                        Tailored Solutions for
                        <span className="jk-industries__title-highlight"> Every Sector</span>
                    </h2>
                    <p className="jk-industries__subtitle">
                        We understand the unique challenges and requirements of different industries,
                        delivering specialized technology solutions that drive success.
                    </p>
                </div>

                {/* Industries Grid */}
                <div className="jk-industries__grid">
                    {industries.map((industry, index) => (
                        <Link
                            key={index}
                            to={industry.link}
                            className="jk-industries__card"
                        >
                            <div className="jk-industries__card-header">
                                <div className="jk-industries__card-icon">
                                    {industry.icon}
                                </div>
                                <span className="jk-industries__card-stats">{industry.stats}</span>
                            </div>
                            <h3 className="jk-industries__card-title">{industry.title}</h3>
                            <p className="jk-industries__card-description">{industry.description}</p>
                            <span className="jk-industries__card-link">
                                Explore Solutions
                                <ArrowRight size={16} />
                            </span>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ModernIndustries;
